import React, { useState, useEffect } from 'react';
import { api } from '../lib/api';
import { toast } from 'sonner';
import { Trophy, User, Check, Clock } from 'lucide-react';

const SpecialEventsTeacherStats = () => {
  const [stats, setStats] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const res = await api.getSpecialEventTeacherStats();
        setStats(res.data);
      } catch (err) {
        toast.error('Failed to load stats');
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
  }, []);

  if (loading) return <div className="text-center py-20 text-slate-400">Loading...</div>;

  return (
    <div className="space-y-6" data-testid="teacher-stats-page">
      <div>
        <h1 className="text-2xl font-bold text-slate-900">Teacher Event Stats</h1>
        <p className="text-sm text-slate-500 mt-1">Special events count per teacher</p>
      </div>

      {stats.length === 0 ? (
        <div className="text-center py-20 text-slate-400">No events assigned yet</div>
      ) : (
        <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
          <table className="w-full">
            <thead className="bg-slate-50">
              <tr>
                <th className="text-left px-6 py-3 text-sm font-medium text-slate-500">#</th>
                <th className="text-left px-6 py-3 text-sm font-medium text-slate-500">Teacher</th>
                <th className="text-center px-6 py-3 text-sm font-medium text-slate-500">Completed</th>
                <th className="text-center px-6 py-3 text-sm font-medium text-slate-500">Pending</th>
                <th className="text-center px-6 py-3 text-sm font-medium text-slate-500">Total</th>
              </tr>
            </thead>
            <tbody>
              {stats.map((s, i) => (
                <tr key={s.teacher_id} className="border-t border-slate-100 hover:bg-slate-50" data-testid={`teacher-row-${s.teacher_id}`}>
                  <td className="px-6 py-4 text-sm text-slate-400">{i + 1}</td>
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-3">
                      <div className="w-8 h-8 bg-rose-100 rounded-full flex items-center justify-center">
                        <User size={16} className="text-rose-600" />
                      </div>
                      <span className="font-medium text-slate-900">{s.teacher_name}</span>
                    </div>
                  </td>
                  <td className="px-6 py-4 text-center">
                    <span className="inline-flex items-center gap-1 px-2.5 py-1 bg-green-100 text-green-700 rounded-full text-sm font-medium">
                      <Check size={14} /> {s.completed}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-center">
                    <span className="inline-flex items-center gap-1 px-2.5 py-1 bg-amber-100 text-amber-700 rounded-full text-sm font-medium">
                      <Clock size={14} /> {s.pending}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-center font-bold text-slate-700">{s.total}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default SpecialEventsTeacherStats;
